// Every role is a company with one or more positions (newest first).
// `subtitle` renders under all positions; a position's `summary` renders under its title.
const roles = [
  {
    id: "kimley-horn",
    company: "Kimley-Horn Technology Solutions",
    subtitle:
      "Building SaaS products for civil engineering firms and municipalities. I do full-stack work with C#, TypeScript, .NET, Angular, and Python.",
    positions: [
      { title: "Software Engineer II", range: "June 2026 – Present", bullets: [] },
      { title: "Software Engineer I", range: "March 2025 – June 2026", bullets: [] }
    ]
  },
  {
    id: "impact-point",
    company: "Impact Point",
    positions: [
      {
        title: "Software Engineer & Co-Founder",
        range: "August 2025 – Present",
        summary: "Joined as technical co-founder to scale a live multiplayer game with 280,000+ players on Steam",
        bullets: [
          "Removed 400+ memory allocations per second from C# bot AI loops using static registries and zero-allocation targeting, eliminating 200ms+ GC-induced latency spikes.",
          "Led a zero-downtime platform migration from Steamworks to PlayFab, preserving live player economy data and progression while enabling cross-platform mobile expansion.",
          "Built a headless CLI harness exposing the full build, run, and validate loop to Claude via MCP, dropping the time to a working prototype from 7+ hours to under 30 minutes.",
          "Moved win-streak logic server-side with event-driven Azure Functions that validate and write end-of-match stats to PlayFab, preventing client-side tampering."
        ]
      }
    ]
  },
  {
    id: "infosys",
    company: "Infosys",
    positions: [
      {
        title: "Software Engineer Intern",
        range: "May 2024 – July 2024",
        bullets: [
          "Shipped a full-stack AI documentation assistant (JavaScript, Python, Flask, LangChain, Azure OpenAI) to parse Excel requirements via few-shot prompting, allowing stakeholders to generate project documents and reducing creation time from 3+ hours to under 5 minutes."
        ]
      }
    ]
  },
  {
    id: "uncw-research",
    company: "UNCW College of Science and Engineering",
    positions: [
      {
        title: "ML Research Assistant",
        range: "September 2022 – January 2024",
        bullets: [
          "First author on a published IEEE paper on search personalization. Created a Python automation suite (Selenium, BeautifulSoup) that simulated user personas to harvest 10,000+ search results, producing a dataset used to train ML models on search engine privacy."
        ]
      }
    ]
  }
];

export default roles;
